import { render, staticRenderFns } from "./BusinessNameDataUpdateTaskQueueLevel3.vue?vue&type=template&id=0dd7821c&scoped=true&"
import script from "./BusinessNameDataUpdateTaskQueueLevel3.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateTaskQueueLevel3.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateTaskQueueLevel3.vue?vue&type=style&index=0&id=0dd7821c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd7821c",
  null
  
)

export default component.exports